module.exports = __webpack_public_path__ + "static/media/POWER RANGERS 3 copy.41ae755b.jpg";